import insert from './insert'
import modify from './modify'
import remove from './remove'

export default {
	insert,
	modify,
	remove
}
